import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin } from 'lucide-react';

const addressOf = (street, postal, city) => [street, [postal, city].filter(Boolean).join(' ')].filter(Boolean).join(', ');

// "Zadání a místo": what the customer wants, where the work is done and who to call there.
const UpgradeScopeCard = ({ job, form, set, locked }) => {
  const siteLocation = (siteId) => {
    const site = job.sites.find((s) => s.id === Number(siteId));
    if (site) return [site.name, addressOf(site.street, site.postal_code, site.city)].filter(Boolean).join(', ');
    return job.customer ? addressOf(job.customer.street, job.customer.postal_code, job.customer.city) : form.location;
  };
  const changeSite = (value) => {
    set('site_id', value ? Number(value) : null);
    set('location', siteLocation(value));
  };
  const pickContact = (value) => {
    if (value === 'main') {
      set('contact_name', job.customer?.name || '');
      set('contact_phone', job.customer?.phone || '');
      set('contact_email', job.customer?.email || '');
      return;
    }
    const c = job.contacts.find((x) => x.id === Number(value));
    if (!c) return;
    set('contact_name', c.name || '');
    set('contact_phone', c.phone || '');
    set('contact_email', c.email || '');
  };

  return (
    <section className="dlv-card" aria-labelledby="upg-scope">
      <h2 id="upg-scope" className="upg-card-title"><MapPin size={18} /> Zadání a místo
        {job.customer_id && <small><Link className="upg-link" to={`/customers/${job.customer_id}`}>{job.customer_name}</Link></small>}
      </h2>
      <div className="upg-fields">
        <div className="full">
          <label className="dlv-label" htmlFor="upg-title">Název úpravy</label>
          <input id="upg-title" className="dlv-input" value={form.title} maxLength={200} disabled={locked} onChange={(e) => set('title', e.target.value)} />
        </div>
        <div className="full">
          <label className="dlv-label" htmlFor="upg-desc">Co zákazník požaduje</label>
          <textarea id="upg-desc" className="dlv-input upg-textarea" value={form.description} disabled={locked} onChange={(e) => set('description', e.target.value)}
            placeholder="Zadání od zákazníka, popis problému nebo přání…" />
        </div>
        <div>
          <label className="dlv-label" htmlFor="upg-site">Provozovna</label>
          <select id="upg-site" className="dlv-input" value={form.site_id || ''} disabled={locked} onChange={(e) => changeSite(e.target.value)}>
            <option value="">Sídlo zákazníka</option>
            {job.sites.map((s) => <option key={s.id} value={s.id}>{s.name}{s.city ? ` – ${s.city}` : ''}</option>)}
          </select>
        </div>
        <div>
          <label className="dlv-label" htmlFor="upg-location">Kde se úprava provede (adresa)</label>
          <input id="upg-location" className="dlv-input" value={form.location} maxLength={1000} disabled={locked} onChange={(e) => set('location', e.target.value)} />
        </div>
        <div className="full">
          <label className="dlv-label" htmlFor="upg-contact-pick">Kontakt na místě</label>
          <select id="upg-contact-pick" className="dlv-input" value="" disabled={locked} onChange={(e) => pickContact(e.target.value)}>
            <option value="">Vybrat z kontaktních osob zákazníka…</option>
            {job.customer && <option value="main">Hlavní kontakt zákazníka</option>}
            {job.contacts.map((c) => <option key={c.id} value={c.id}>{c.name}{c.position ? ` (${c.position})` : ''}</option>)}
          </select>
        </div>
        <div>
          <label className="dlv-label" htmlFor="upg-cname">Jméno</label>
          <input id="upg-cname" className="dlv-input" value={form.contact_name} maxLength={255} disabled={locked} onChange={(e) => set('contact_name', e.target.value)} />
        </div>
        <div>
          <label className="dlv-label" htmlFor="upg-cphone">Telefon</label>
          <input id="upg-cphone" className="dlv-input" type="tel" value={form.contact_phone} maxLength={50} disabled={locked} onChange={(e) => set('contact_phone', e.target.value)} />
        </div>
        <div className="full">
          <label className="dlv-label" htmlFor="upg-cmail">E-mail</label>
          <input id="upg-cmail" className="dlv-input" type="email" value={form.contact_email} maxLength={255} disabled={locked} onChange={(e) => set('contact_email', e.target.value)} />
        </div>
      </div>
    </section>
  );
};

export default UpgradeScopeCard;
